import React, { useState } from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../logo.svg";
import {
  FiHome,
  FiList,
  FiPlus,
  FiUser,
  FiLogOut,
  FiMenu,
  FiX,
  FiAward,
} from "react-icons/fi";

export default function ProviderLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { to: "/provider", label: "Dashboard", icon: FiHome },
    { to: "/provider/listings", label: "My Listings", icon: FiList },
    { to: "/provider/certificate", label: "Certificate", icon: FiAward },
    { to: "/provider/profile", label: "Profile", icon: FiUser },
    { to: "/provider/create", label: "Create Listing", icon: FiPlus },
  ];

  return (
    <div className="flex h-screen poppins-regular bg-gray-50">
      {/* Mobile topbar */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-20 bg-gray-900 text-white flex items-center justify-between px-4 py-3 shadow">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="OnlineIndianMarket" className="h-7 w-7" />
          <span className="text-2xl font-semibold">OIM</span>
        </Link>
        <button onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? (
            <FiX className="h-6 w-6" />
          ) : (
            <FiMenu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`fixed md:static inset-y-0 left-0 z-30 w-60 text-white flex flex-col bg-gradient-to-b from-gray-900 via-gray-800 to-gray-700 transform transition-transform duration-300 md:translate-x-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <Link
          to="/"
          className="px-4 py-4 flex items-center gap-3 cursor-pointer hidden md:flex"
        >
          <img src={logo} alt="OnlineIndianMarket" className="h-8 w-8" />
          <span className="text-3xl font-semibold tracking-wide">OIM</span>
        </Link>
        <div className="h-px bg-white/10 mx-4 hidden md:block" />

        <nav className="px-3 py-3 space-y-1 overflow-y-auto flex-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/provider"}
              className={({ isActive }) =>
                `block w-full text-left px-3 py-2 rounded-md transition-colors duration-150 ${
                  isActive ? "bg-white/10" : "hover:bg-white/5"
                }`
              }
              onClick={() => setSidebarOpen(false)} // close on mobile click
            >
              <span className="flex items-center gap-2">
                <Icon className="h-5 w-5" />
                <span>{label}</span>
              </span>
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto px-3 pb-4 space-y-2">
          <button
            onClick={() => {
              logout();
              navigate("/signin");
            }}
            className="block w-full text-left px-3 py-2 rounded-md text-gray-300 hover:text-white hover:bg-white/5 transition-colors duration-150"
          >
            <span className="flex items-center gap-2">
              <FiLogOut className="h-5 w-5" />
              <span>Logout</span>
            </span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 p-6 overflow-y-auto md:ml-0 mt-14 md:mt-0">
        <Outlet />
      </main>
    </div>
  );
}
